import app from 'flarum/app';
import Modal from 'flarum/components/Modal';
import sortTags from 'flarum/tags/utils/sortTags';
import tagIcon from 'flarum/tags/helpers/tagIcon';
import Switch from 'flarum/components/Switch';
import Button from 'flarum/components/Button';
import skipTags from '../actions/skipTags';

export default class PreferredTagsModal extends Modal {

    // overrides variable in the extended Super class (modal) so it can only be closed programatically
    static isDismissible = false;
    checkboxValues;
    tags;
    loading = false;
    user;
    currentTagSlug;
    isFirstTimeSettingPreferrences;
    forcedPreferredStyling = {
        className: 'disabled',
        title: app.translator.trans('preferred-tags.forum.forced_preferred_tooltip')
    };
    newTagStyling = { className: 'NewTagLine' };


    oninit(vnode) {
        super.oninit(vnode);
        this.checkboxValues = {};
        this.tags = app.store.all('tags').filter(t => t.position() != null);

        this.isFirstTimeSettingPreferrences = this.tags.filter(t => t.isPreferred() != null).length === 0;

        this.currentTagSlug = m.route.param('tags');

        this.user = app.session.user;

        // from the existing tags - populate checkbox values
        this.tags.forEach(t => {
            if (t.isForcedPreferred()) {
                this.checkboxValues[t.id()] = true;
            } else {
                if (this.user.data.attributes.isFirstTimeSettingPreferrences) {
                    this.checkboxValues[t.id()] = false;
                } else {
                    this.checkboxValues[t.id()] = t.isPreferred() || false;
                }
            }
        })

        this.user = app.session.user;
    }

    className() {
        return 'PreferredTagsModal';
    }

    title() {
        return app.translator.trans('preferred-tags.forum.title');
    }

    content() {
        return [
            m('p.PreferredTagsDescription', app.translator.trans('preferred-tags.forum.description')),
            m('.Modal-body.PreferredTags',
            m('table.PreferredTagsTable',
                m('tbody', sortTags(this.tags).filter(t => !t.data.attributes.isChild)
                .map(tag => m('tr.PreferredTagRow', tag.isPreferred() === null ? this.newTagStyling: {}, [
                    m('td.PreferredTagIcon', [
                        tag.data.attributes.isPreferred === null ? m('span.NewTagBadge', 'NY') : null,
                        tagIcon(tag)
                    ]),
                    m('td.PreferredTagName', [
                        tag.name()
                    ]),
                    m('td.PreferredTagSwitch', tag.isForcedPreferred() ? this.forcedPreferredStyling : {},
                        [
                        Switch.component({
                            state: this.checkboxValues[tag.id()] || false,
                            disabled: this.loading,
                            onchange: () => {
                                // make it so we cannot deselect a tag we are currently watching
                                if(tag.data.attributes.slug === this.currentTagSlug || tag.isForcedPreferred()) {
                                    this.checkboxValues[tag.id()] = true;
                                } else {
                                    this.checkboxValues[tag.id()] = !this.checkboxValues[tag.id()];
                                }
                            }
                        })
                    ])
                ])))
            )),
            m('.Modal-body.PreferredTags-footer', [
                this.isFirstTimeSettingPreferrences ? m('span.PreferredTags-footer-spacer') : m('a.PreferredTags-footer-link', {
                    onclick: () => {
                        this.loading = true;
                        skipTags(this.isFirstTimeSettingPreferrences, this.tags.filter(t => t.isPreferred() === null))
                            .then(() => {
                                this.loading = false;
                                app.modal.close();
                            });
                    }
                }, app.translator.trans('preferred-tags.forum.skip')),
                Button.component({
                    loading: this.loading,
                    className: 'Button Button--primary SaveButton',
                    disabled: Object.keys(this.checkboxValues).filter(k => this.checkboxValues[k] === true || this.checkboxValues[k] === 1).length === 0,
                    onclick: () => {
                        this.loading = true;

                        app.request({
                            url: `${app.forum.attribute('apiUrl')}/tags/preferred`,
                            method: 'POST',
                            body: {
                                preferredTags: this.checkboxValues
                            }
                        }).then((res) => {
                            return app.store.pushPayload(res)
                        })
                        .then(() => {
                            this.loading = false;
                            app.modal.close();
                            app.alerts.show({
                                type: 'success'
                            }, app.translator.trans('preferred-tags.forum.saved'));

                            // clear alerts after 10 seconds
                            setTimeout(() => {
                                app.alerts.clear();
                            }, 10000);

                            // clear skip preferred from session since we have now taken action
                            sessionStorage.removeItem('preferred_skip_check');

                            setTimeout(() => {
                                m.redraw();
                            }, 500); // timeout is necessary for mithrill to have time to settle the store update before redrawing the ui
                        });

                    }
                }, app.translator.trans('preferred-tags.forum.save-button'))
            ])
        ];
    }

    onsubmit(event) {
        event.preventDefault();
    }

}
